<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="validate">
      <h5 class="text-center">English Section</h5>
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <div class="row">
            <div class="col-md-6">
              <ValidationProvider
                vid="title"
                rules="required"
                name="The Title"
                v-slot="{ passed, failed,errors }">
                <fg-input type="text"
                          :error="failed ? errors[0]: null"
                          label="title"
                          name="title"
                          fou
                          @keyup="generateSomeFields"
                          v-model="formData.title">
                </fg-input>
              </ValidationProvider>
            </div>
            <div class="col-md-6">
              <ValidationProvider
                vid="url"
                rules="required"
                name="The URL"
                v-slot="{ passed, failed,errors }">
                <fg-input type="text"
                          :error="failed ? errors[0]: null"
                          label="URL"
                          name="url"
                          fou
                          v-model="formData.url">
                </fg-input>
              </ValidationProvider>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <ValidationProvider
                vid="news_type_id"
                rules="required"
                name="The Type"
                v-slot="{ passed, failed,errors }">
                <fg-select
                  :error="failed ? errors[0]: null"
                  name="news_type_id"
                  size="large"
                  filterable
                  clearable
                  placeholder="Select Type"
                  :input-classes="'select-default'"
                  :label="'Type'"
                  :list="builderData.newsType"
                  :listItemLabel="'name'"
                  :listItemValue="'id'"
                  v-model="formData.news_type_id">
                </fg-select>
              </ValidationProvider>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <ValidationProvider
                vid="link"
                rules=""
                name="The Link"
                v-slot="{ passed, failed,errors }">
                <fg-input type="text"
                          :error="failed ? errors[0]: null"
                          label="Link"
                          name="link"
                          fou
                          v-model="formData.link">
                </fg-input>
              </ValidationProvider>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <ValidationProvider
                vid="location"
                rules=""
                name="The Location"
                v-slot="{ passed, failed,errors }">
                <fg-input type="text"
                          :error="failed ? errors[0]: null"
                          label="Location"
                          name="location"
                          fou
                          v-model="formData.location">
                </fg-input>
              </ValidationProvider>
            </div>
            <div class="col-md-6">
              <label class="card-label">Date</label>
              <fg-input v-model="formData.date"
                        value-format="YYYY-MM-DD HH:MM:SS"
                        type="datetime-local"
                        placeholder="Chose news date"
              >
              </fg-input>
            </div>
          </div>
          <ValidationProvider
            vid="video_type"
            rules=""
            name="The Video Type"
            v-slot="{ passed, failed,errors }">
            <fg-select
              name="video_type"
              size="large"
              filterable
              clearable
              placeholder="Video Type"
              :error="failed ? errors[0]: null"
              :input-classes="'select-default'"
              :label="'Video Type'"
              :list="builderData.VideoTypes"
              :listItemLabel="'label'"
              :listItemValue="'value'"
              v-model="formData.video_type">
            </fg-select>
          </ValidationProvider>
          <div class="form-group" v-if="formData.video_type === 'UPLOADED'">
            <label>Uploaded Video</label>
            <el-tooltip placement="right" v-if="false">
              <div slot="content"></div>
              <span style="margin: 0 5px;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-question-circle" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                      <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>
                    </svg>
                    </span>
            </el-tooltip>
            <single-file-uploader-file-manager  :preview-width="'200px'"
                                                :preview-height="'200px'"
                                                v-model="formData.uploaded_video"
                                                :accepted-files="videosExtensions">

            </single-file-uploader-file-manager>
          </div>
          <div class="form-group" v-if="formData.video_type == 'EMBEDDED'">
            <el-tooltip placement="right" v-if="false">
              <div slot="content"></div>
              <span style="margin: 0 5px;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-question-circle" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                      <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>
                    </svg>
                    </span>
            </el-tooltip>
            <ValidationProvider
              vid="embedded_video"
              rules=""
              name="The Embedded Video"
              v-slot="{ passed, failed,errors }">
              <fg-input type="text"
                        :error="failed ? errors[0]: null"
                        label="Embedded Video"
                        name="embedded_video"
                        fou
                        v-model="formData.embedded_video">
              </fg-input>
            </ValidationProvider>
            <div v-html="formData.embedded_video">
            </div>
          </div>
          <div class="form-group">
            <label>Image</label>
            <el-tooltip placement="right" >
              <div slot="content"> (548 * 548)</div>
              <span style="margin: 0 5px;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                             class="bi bi-question-circle" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                      <path
                        d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>
                    </svg>
                    </span>
            </el-tooltip>
            <single-file-uploader-file-manager
              :preview-width="'200px'"
              :preview-height="'200px'"
              v-model="formData.image"
              :accepted-files="imagesExtensions">
            </single-file-uploader-file-manager>
          </div>
          <div class="form-group">
            <label>Content</label>
            <editor
              v-model="formData.content"
              :api-key="editorKey"
              :init='editorConfig'
            />
          </div>
          <ValidationProvider
            vid="linked_initiatives"
            rules=""
            name="The Linked Initiatives"
            v-slot="{ passed, failed,errors }">
            <div>
              <small style="color: #666; font-size: 11px; display: block; margin-bottom: 5px;">
                Debug: 
                Direct = {{ JSON.stringify(formData.linked_initiatives) }}
                | Computed = {{ JSON.stringify(linkedInitiativesValue) }}
                | Backup = {{ JSON.stringify(storedLinkedInitiatives) }}
                <br>
                Other fields: initiatives = {{ JSON.stringify(formData.initiatives) }} | initiative = {{ JSON.stringify(formData.initiative) }}
                <br>
                Available = {{ (builderData.initiatives && builderData.initiatives.length) || 0 }}
              </small>
              <fg-select
                :key="'linked_initiatives_' + JSON.stringify(linkedInitiativesValue)"
                name="linked_initiatives"
                size="large"
                filterable
                clearable
                multiple
                placeholder="Select Initiatives"
                :input-classes="'select-default'"
                :label="'Linked Initiatives'"
                :list="builderData.initiatives || []"
                :listItemLabel="'title'"
                :listItemValue="'id'"
                v-model="linkedInitiativesValue">
              </fg-select>
            </div>
          </ValidationProvider>
          <div class="form-group">
            <label>Gallery</label>
            <el-tooltip placement="right" v-if="false">
              <div slot="content"></div>
              <span style="margin: 0 5px;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                             class="bi bi-question-circle" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                      <path
                        d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>
                    </svg>
                    </span>
            </el-tooltip>
            <multiple-file-uploader-file-manager
              :preview-width="'200px'"
              :preview-height="'200px'"
              v-model="formData.gallery"
              :files-number="30"
              :accepted-files="imagesExtensions">
            </multiple-file-uploader-file-manager>
          </div>
          <div class="form-group">
            <label>PDF</label>
            <el-tooltip placement="right" v-if="false">
              <div slot="content"></div>
              <span style="margin: 0 5px;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                             class="bi bi-question-circle" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                      <path
                        d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>
                    </svg>
                    </span>
            </el-tooltip>
            <multiple-file-uploader-file-manager
              :preview-width="'200px'"
              :preview-height="'200px'"
              v-model="formData.files"
              :files-number="30"
              :fileType="'document'"
              :accepted-files="pdfExtensions">
            </multiple-file-uploader-file-manager>
          </div>
          <div class="col-md-8">
            <div class="">
              <label>Writers</label>
              <div class="col-12">
                <template class="row" v-for="(item, itemIndex) in formData.writers">
                  <div class="col-md-12">
                    <fg-input type="text"
                              :key="itemIndex"
                              :label="'Writer '+(itemIndex+1)"
                              v-model="formData.writers[itemIndex]">
                    </fg-input>
                  </div>
                  <div class="col-sm-1 align-self-center mt-3">
                    <l-button
                      @click="removeWriter(formData.writers, itemIndex)"
                      type="danger" size="sm">
                      <i class="fa fa-trash"></i>
                    </l-button>
                  </div>
                </template>
                <l-button
                  class="mt-3"
                  type="success"
                  @click="addNewWriter(formData.writers, '')"
                  size="sm">
                  <i class="fa fa-plus"></i>
                </l-button>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-between">
            <div class="form-group pt-4">
              <label>Is Active</label>&nbsp;
              <l-switch v-model="formData.is_active">
                <i class="fa fa-check" slot="on"></i>
                <i class="fa fa-times" slot="off"></i>
              </l-switch>
            </div>
            <div class="form-group pt-4">
              <label>Is Featured</label>&nbsp;
              <l-switch v-model="formData.is_featured">
                <i class="fa fa-check" slot="on"></i>
                <i class="fa fa-times" slot="off"></i>
              </l-switch>
            </div>
            <div class="form-group pt-4" v-if="editMode">
              <label>Project Updated ?</label>&nbsp;
              <l-switch v-model="formData.is_updated">
                <i class="fa fa-check" slot="on"></i>
                <i class="fa fa-times" slot="off"></i>
              </l-switch>
            </div>
            <div class="form-group pt-4">
              <label>Display in popup</label>&nbsp;
              <l-switch v-model="formData.show_in_popup">
                <i class="fa fa-check" slot="on"></i>
                <i class="fa fa-times" slot="off"></i>
              </l-switch>
            </div>
          </div>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
  import { extend } from "vee-validate";
  import { required, email } from "vee-validate/dist/rules";
  import {Option, Select, Tooltip} from "element-ui";
  import FgSelect from "@/components/Inputs/formGroupSelect";
  import FormGroupTextArea, {ImageUploader, PrimeUploader, PrimeVideoUploader, Switch as LSwitch} from "@/components";
  import Editor from '@tinymce/tinymce-vue'
  import SingleFileUploaderFileManager from "../../../components/FileManager/SingleFileUploaderFileManager";
  import MultipleFileUploaderFileManager from "../../../components/FileManager/MultipleFileUploaderFileManager";

  extend("required", required);
  extend("email", email);

  export default {
    components: {
      MultipleFileUploaderFileManager,
      SingleFileUploaderFileManager,
      FormGroupTextArea,
      [Option.name]: Option,
      [Select.name]: Select,
      [Tooltip.name]: Tooltip,
      FgSelect,
      LSwitch,
      PrimeUploader,
      ImageUploader,
      PrimeVideoUploader,
      'editor': Editor
    },
    props: {
      lang: {
        type: String,
        default: 'en'
      },
      editMode: {
        type: Boolean,
        default: false
      },
      builderData:{},
      formData:{
        type: Object,
        default() {
          return {
            title: "",
            url: "",
            news_type_id: "",
            image: "",
            content: "",
            is_active: true,
            show_in_popup: false,
            is_featured: false,
            gallery: [],
            linked_initiatives: [],
            date: null,
            files: [],
            video_type: '',
            uploaded_video: "",
            embedded_video: "",
            writers: [],
          }
        }
      },
    },
    data() {
      return {
        editorConfig: this.getEditorConfig(),
        editorKey: process.env.VUE_APP_TINY_EDITOR_KEY,
        imagesExtensions: this.getImagesExtensions(),
        pdfExtensions: this.getPdfExtensions(),
        videosExtensions: this.getVideoExtensions(),
        storedLinkedInitiatives: [], // Backup of linked initiatives to prevent data loss
      };
    },
    computed: {
      linkedInitiativesValue: {
        get() {
          const value = this.formData.linked_initiatives;
          console.log("🔄 EnglishStep: computed get linked_initiatives:", value);
          
          // If we have stored a value but formData is reset, restore it
          if ((!value || value.length === 0) && this.storedLinkedInitiatives && this.storedLinkedInitiatives.length > 0) {
            console.log("🔄 Restoring linked initiatives from backup:", this.storedLinkedInitiatives);
            this.formData.linked_initiatives = this.storedLinkedInitiatives;
            return this.storedLinkedInitiatives;
          }
          
          return value || [];
        },
        set(newValue) {
          console.log("🔄 EnglishStep: computed set linked_initiatives:", newValue);
          this.formData.linked_initiatives = newValue;
          // Store a backup to restore if data gets reset
          this.storedLinkedInitiatives = [...(newValue || [])];
        }
      }
    },
    watch: {
      'formData.linked_initiatives': {
        handler(newVal, oldVal) {
          // Detect if data is being cleared unexpectedly
          if (oldVal && oldVal.length > 0 && (!newVal || newVal.length === 0)) {
            console.warn("❌ EnglishStep: linked_initiatives was CLEARED!", {
              old: oldVal,
              new: newVal,
              stack: new Error().stack
            });
            
            // Restore from backup if available
            if (this.storedLinkedInitiatives && this.storedLinkedInitiatives.length > 0) {
              console.log("🔄 Auto-restoring from backup:", this.storedLinkedInitiatives);
              this.$nextTick(() => {
                this.formData.linked_initiatives = [...this.storedLinkedInitiatives];
              });
            }
          } else {
            console.log("🔄 EnglishStep: linked_initiatives prop changed", {
              old: oldVal,
              new: newVal,
              formDataKeys: Object.keys(this.formData)
            });
          }
        },
        deep: true,
        immediate: true
      },
      formData: {
        handler(newVal, oldVal) {
          // Check if entire formData is being replaced
          if (oldVal && newVal && oldVal !== newVal) {
            console.warn("❌ EnglishStep: entire formData object was REPLACED!", {
              hasLinkedInitiatives: 'linked_initiatives' in newVal,
              linkedInitiativesValue: newVal.linked_initiatives,
              stack: new Error().stack
            });
          }
        },
        deep: false // Only watch for object replacement, not deep changes
      }
    },
    methods: {
      validate() {
        return this.$refs.form.validate().then(res => {
          if (res){
            this.$emit('submit-step', this.formData, this.lang)
          }else{
            this.$emit('on-validated', res)
          }
          return res
        });
      },
      generateSomeFields() {
        if(this.editMode){
          return;
        }
        let newUrl = '';
        if (this.formData.title) {
          newUrl = this.formData.title.replace(/\s+/g, "-").toLowerCase();
          newUrl = newUrl.replace(/[^ءأ-يa-zA-Z0-9-]/g, "");
          newUrl = newUrl.replace(/([-]+)/g, "_");
        }

        this.formData.url = newUrl;
      },
      addNewWriter(writers, listObject){
        writers.push(listObject);
      },
      removeWriter(writers, index) {
        writers.splice(index, 1);
      },
      updateLinkedInitiatives(newValue) {
        console.log("🔄 EnglishStep: updateLinkedInitiatives called with:", newValue);
        this.formData.linked_initiatives = newValue;
        this.storedLinkedInitiatives = [...(newValue || [])];
        this.$forceUpdate();
        console.log("🔄 EnglishStep: After manual update, linked_initiatives =", this.formData.linked_initiatives);
        console.log("🔄 EnglishStep: Stored backup =", this.storedLinkedInitiatives);
      },
    }
  }
</script>
<style>
</style>
